export default "__VITE_ASSET__zY$NrAVp__"